/**
 * Ingredient Glossary — mobile-first directory + bottom sheet detail panel.
 */
(function () {
  const root = document.querySelector('[data-bb-ing-glossary]');
  if (!root) return;

  const configEl = root.querySelector('[data-bb-ing-config]');
  const lookupUrl = root.getAttribute('data-bb-ing-lookup-url');
  const railTrack = root.querySelector('[data-bb-ing-rail-track]');
  const directoryEl = root.querySelector('[data-bb-ing-directory]');
  const loadingEl = root.querySelector('[data-bb-ing-loading]');
  const countEl = root.querySelector('[data-bb-ing-count]');
  const detailEl = root.querySelector('[data-bb-ing-detail]');
  const detailContent = root.querySelector('[data-bb-ing-detail-content]');
  const backdropEl = root.querySelector('[data-bb-ing-backdrop]');
  const closeBtn = root.querySelector('[data-bb-ing-close]');
  const searchRoot = root.querySelector('[data-bb-ing-search]');
  const searchInput = root.querySelector('[data-bb-ing-search-input]');
  const searchList = root.querySelector('[data-bb-ing-search-list]');
  const searchClear = root.querySelector('[data-bb-ing-search-clear]');
  const searchNoResults =
    (searchRoot && searchRoot.getAttribute('data-bb-ing-search-no-results')) ||
    'No matching ingredients';

  let config = {};
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  let data = { sections: [], lookup: {}, letterRail: [], total: 0 };
  let searchIndex = [];
  let activeLang = 'en';
  let activeSlug = '';
  let activeLetter = '';
  let scrollSpyLocked = false;
  let scrollSpyTicking = false;
  let mobileMq = window.matchMedia('(max-width: 749px)');
  let searchActiveIndex = -1;
  let searchResults = [];
  let searchDebounceTimer = null;
  const SEARCH_LIMIT = 10;

  function getAnchorOffset() {
    const styles = getComputedStyle(root);
    const header =
      parseFloat(styles.getPropertyValue('--bb-ing-header-offset')) || 164;
    const rail = parseFloat(styles.getPropertyValue('--bb-ing-rail-height')) || 40;
    return header + rail + 10;
  }

  function syncStickyOffset() {
    const header = document.querySelector('.bb-header');
    const utility = document.querySelector('.utility-bar');
    let offset = 0;
    if (header) offset += header.getBoundingClientRect().height;
    if (utility) offset += utility.getBoundingClientRect().height;
    if (offset > 0) {
      root.style.setProperty('--bb-ing-header-offset', offset + 'px');
    }
  }

  function setActiveLetter(letter, scrollRailIntoView) {
    if (!letter || !railTrack) return;
    const changed = activeLetter !== letter;
    activeLetter = letter;

    railTrack.querySelectorAll('[data-bb-ing-letter]').forEach(function (btn) {
      const isMatch = btn.getAttribute('data-bb-ing-letter') === letter;
      btn.classList.toggle('is-active', isMatch && !btn.disabled);
      if (isMatch) {
        btn.setAttribute('aria-current', 'true');
        if (scrollRailIntoView) {
          btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      } else {
        btn.removeAttribute('aria-current');
      }
    });

    if (changed && scrollRailIntoView && isMobile()) {
      /* scrollIntoView on button handled above */
    }
  }

  function updateActiveLetterFromScroll() {
    if (scrollSpyLocked || root.classList.contains('is-detail-open') || !directoryEl) {
      return;
    }

    const anchor = getAnchorOffset();
    const sections = directoryEl.querySelectorAll('.bb-ing-glossary__section');
    if (!sections.length) return;

    let current = sections[0];
    sections.forEach(function (sec) {
      if (sec.getBoundingClientRect().top <= anchor) {
        current = sec;
      }
    });

    const letter =
      current.getAttribute('data-bb-ing-letter') ||
      (current.id || '').replace('bb-ing-section-', '');
    if (letter) {
      setActiveLetter(letter, true);
    }
  }

  function onScrollSpy() {
    if (scrollSpyTicking) return;
    scrollSpyTicking = true;
    requestAnimationFrame(function () {
      updateActiveLetterFromScroll();
      scrollSpyTicking = false;
    });
  }

  function initScrollSpy() {
    teardownScrollSpy();
    window.addEventListener('scroll', onScrollSpy, { passive: true });
    root._bbIngScrollSpy = onScrollSpy;
    updateActiveLetterFromScroll();
  }

  function teardownScrollSpy() {
    if (root._bbIngScrollSpy) {
      window.removeEventListener('scroll', root._bbIngScrollSpy);
      root._bbIngScrollSpy = null;
    }
  }

  function scrollToLetterSection(letter) {
    const target = root.querySelector('#bb-ing-section-' + CSS.escape(letter));
    if (!target) return;

    scrollSpyLocked = true;
    setActiveLetter(letter, true);
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    window.setTimeout(function () {
      scrollSpyLocked = false;
      updateActiveLetterFromScroll();
    }, 700);
  }

  function isMobile() {
    return mobileMq.matches;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function dashIfEmpty(val) {
    return val && String(val).trim() ? val : '—';
  }

  function displayInciName(name) {
    if (typeof formatInciDisplayName === 'function') {
      return formatInciDisplayName(name);
    }
    return name;
  }

  function getStoredLang() {
    try {
      return sessionStorage.getItem('bb-ing-lang');
    } catch (e) {
      return null;
    }
  }

  function setStoredLang(lang) {
    try {
      sessionStorage.setItem('bb-ing-lang', lang);
    } catch (e) {
      /* ignore */
    }
  }

  function initLang() {
    const stored = getStoredLang();
    if (stored === 'en' || stored === 'zh') {
      activeLang = stored;
    } else {
      activeLang = document.documentElement.lang.startsWith('zh') ? 'zh' : 'en';
    }
  }

  function openDetailPanel() {
    if (!detailEl) return;
    detailEl.hidden = false;
    root.classList.add('is-detail-open');
    if (backdropEl) {
      backdropEl.hidden = false;
      backdropEl.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeDetailPanel() {
    root.classList.remove('is-detail-open');
    if (backdropEl) {
      backdropEl.hidden = true;
      backdropEl.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
    if (detailEl) {
      detailEl.hidden = true;
    }
    activeSlug = '';
    root.querySelectorAll('.bb-ing-glossary__link.is-selected').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    const url = new URL(window.location.href);
    if (url.searchParams.has('i')) {
      url.searchParams.delete('i');
      history.replaceState(null, '', url.toString());
    }
    updateActiveLetterFromScroll();
  }

  function resolveCategories(entry) {
    const cats = entry.categories || [];
    const ordered = [];
    if (cats.indexOf('skincare') >= 0) ordered.push('skincare');
    if (cats.indexOf('haircare') >= 0) ordered.push('haircare');
    if (!ordered.length) {
      ordered.push(config.defaultCategory || 'skincare');
    }
    return ordered;
  }

  function categoryBlock(entry, cat, lang) {
    if (cat === 'haircare') {
      return lang === 'zh' ? entry.haircare_zh || {} : entry.haircare || {};
    }
    return lang === 'zh' ? entry.skincare_zh || {} : entry.skincare || {};
  }

  function categoryLabelSuffix(cat, lang) {
    if (lang === 'zh') {
      return cat === 'haircare' ? '（護髮）' : '（護膚）';
    }
    return cat === 'haircare' ? ' (haircare)' : ' (skincare)';
  }

  function buildCategoryFieldsHtml(entry, lang) {
    const labels = config.labels || {};
    const categories = resolveCategories(entry);
    let html = '';

    categories.forEach(function (cat, index) {
      const block = categoryBlock(entry, cat, lang);
      const suffix = categoryLabelSuffix(cat, lang);
      const fnBase = lang === 'zh' ? labels.primaryFunctionZh : labels.primaryFunction;
      const cautBase = lang === 'zh' ? labels.cautionsZh : labels.cautions;
      const mechBase = lang === 'zh' ? labels.mechanismZh : labels.mechanism;

      if (index > 0) {
        html += '<hr class="bb-ing-detail__divider">';
      }

      html +=
        fieldHtml(fnBase + suffix, block.function) +
        fieldHtml(cautBase + suffix, dashIfEmpty(block.cautions)) +
        fieldHtml(mechBase + suffix, block.mechanism);
    });

    return html;
  }

  function countListedProducts(entry) {
    if (typeof entry.product_link_count === 'number') {
      return entry.product_link_count;
    }
    let total = 0;
    const brands = entry.products_by_brand || {};
    Object.keys(brands).forEach(function (brand) {
      total += (brands[brand] || []).length;
    });
    return total;
  }

  function shouldHideProductList(entry) {
    if (entry.products_listing === 'hidden') return true;
    if (entry.products_listing === 'available') return false;
    const threshold = config.maxProductListing || 50;
    return countListedProducts(entry) > threshold;
  }

  function buildTooManyProductsMessage(lang) {
    const labels = config.labels || {};
    const title =
      lang === 'zh' ? labels.tooManyProductsTitleZh : labels.tooManyProductsTitle;
    const body =
      lang === 'zh' ? labels.tooManyProductsBodyZh : labels.tooManyProductsBody;
    if (!title && !body) return '';
    return (
      '<hr class="bb-ing-detail__divider">' +
      '<div class="bb-ing-detail__notice" role="status">' +
      (title
        ? '<p class="bb-ing-detail__notice-title">' + escapeHtml(title) + '</p>'
        : '') +
      (body
        ? '<p class="bb-ing-detail__notice-body">' + escapeHtml(body) + '</p>'
        : '') +
      '</div>'
    );
  }

  function countVisibleProducts(entry) {
    let total = 0;
    const brands = entry.products_by_brand || {};
    Object.keys(brands).forEach(function (brand) {
      total += (brands[brand] || []).filter(function (p) {
        return p && p.url;
      }).length;
    });
    return total;
  }

  function buildUnpublishedProductsMessage(lang) {
    const labels = config.labels || {};
    const title =
      lang === 'zh'
        ? labels.unpublishedProductsTitleZh
        : labels.unpublishedProductsTitle;
    const body =
      lang === 'zh'
        ? labels.unpublishedProductsBodyZh
        : labels.unpublishedProductsBody;
    if (!title && !body) return '';
    return (
      '<div class="bb-ing-detail__notice" role="status">' +
      (title
        ? '<p class="bb-ing-detail__notice-title">' + escapeHtml(title) + '</p>'
        : '') +
      (body
        ? '<p class="bb-ing-detail__notice-body">' + escapeHtml(body) + '</p>'
        : '') +
      '</div>'
    );
  }

  function buildProductsHtml(entry, lang) {
    if (shouldHideProductList(entry)) {
      return buildTooManyProductsMessage(lang);
    }
    const brands = entry.products_by_brand || {};
    const brandNames = Object.keys(brands).sort(function (a, b) {
      return a.localeCompare(b);
    });
    const visibleCount = countVisibleProducts(entry);
    if (!visibleCount) {
      if (countListedProducts(entry) > 0) {
        return (
          '<hr class="bb-ing-detail__divider">' +
          '<div class="bb-ing-detail__field">' +
          '<p class="bb-ing-detail__field-label">' +
          escapeHtml(
            lang === 'zh'
              ? config.labels.foundInProductsZh
              : config.labels.foundInProducts
          ) +
          '</p>' +
          buildUnpublishedProductsMessage(lang) +
          '</div>'
        );
      }
      return '';
    }
    const heading =
      lang === 'zh' ? config.labels.foundInProductsZh : config.labels.foundInProducts;
    let html =
      '<hr class="bb-ing-detail__divider">' +
      '<div class="bb-ing-detail__field">' +
      '<p class="bb-ing-detail__field-label">' +
      escapeHtml(heading) +
      '</p>';

    brandNames.forEach(function (brand) {
      html += '<div class="bb-ing-detail__brand">';
      html += '<h4 class="bb-ing-detail__brand-name">' + escapeHtml(brand) + '</h4>';
      html += '<div class="bb-ing-detail__products bb-ing-detail__products-grid">';
      (brands[brand] || []).forEach(function (prod) {
        if (!prod.url) return;
        const thumb = prod.image
          ? '<img class="bb-ing-detail__product-thumb" src="' +
            escapeHtml(prod.image) +
            '" alt="" width="64" height="64" loading="lazy">'
          : '';
        html +=
          '<a class="bb-ing-detail__product" href="' +
          escapeHtml(prod.url) +
          '">' +
          thumb +
          '<span class="bb-ing-detail__product-title">' +
          escapeHtml(prod.title) +
          '</span></a>';
      });
      html += '</div></div>';
    });
    html += '</div>';
    return html;
  }

  function buildDetailHtml(entry) {
    const lang = activeLang;
    const tag =
      lang === 'zh'
        ? entry.tag_zh || entry.tag_en
        : entry.tag_en || entry.tag_zh;
    const alsoKnown = entry.also_known_as || '';
    const labels = config.labels;

    let html = '<div class="bb-ing-detail__header">';
    html +=
      '<h2 class="bb-ing-detail__title" id="bb-ing-detail-title">' +
      escapeHtml(displayInciName(entry.name)) +
      '</h2>';

    if (tag) {
      html +=
        '<p class="bb-ing-detail__tag"><span class="bb-ing-detail__tag-dot"></span>' +
        escapeHtml(tag) +
        '</p>';
    }

    html += '<div class="bb-ing-detail__badges">';
    if (entry.concentration) {
      html +=
        '<span class="bb-ing-detail__badge bb-ing-detail__badge--claim">' +
        escapeHtml(labels.brandClaim) +
        ' ' +
        escapeHtml(entry.concentration) +
        '</span>';
    }
    if (config.showEvidenceTier && entry.evidence_tier) {
      html +=
        '<span class="bb-ing-detail__badge bb-ing-detail__badge--ocr">' +
        escapeHtml(labels.ocrLabel) +
        '</span>';
    }
    if (alsoKnown) {
      html +=
        '<span class="bb-ing-detail__badge bb-ing-detail__badge--alias">' +
        escapeHtml(labels.alsoSeenAs) +
        ': ' +
        escapeHtml(alsoKnown) +
        '</span>';
    }
    html += '</div></div>';

    html +=
      '<div class="bb-ing-detail__lang" role="group" aria-label="Language">' +
      '<button type="button" class="bb-ing-detail__lang-btn' +
      (lang === 'en' ? ' is-active' : '') +
      '" data-bb-ing-lang="en">EN</button>' +
      '<button type="button" class="bb-ing-detail__lang-btn' +
      (lang === 'zh' ? ' is-active' : '') +
      '" data-bb-ing-lang="zh">中文</button>' +
      '</div>';

    html +=
      fieldHtml(
        lang === 'zh' ? labels.commonlyKnownAsZh : labels.commonlyKnownAs,
        lang === 'zh' ? entry.tag_zh || alsoKnown : alsoKnown || entry.tag_en
      ) +
      '<hr class="bb-ing-detail__divider">' +
      buildCategoryFieldsHtml(entry, lang) +
      buildProductsHtml(entry, lang);

    if (config.showSource && entry.source) {
      html +=
        '<div class="bb-ing-detail__footer"><span>' +
        escapeHtml(labels.source) +
        ': ' +
        escapeHtml(entry.source.replace(/_/g, ' ')) +
        '</span></div>';
    }

    return html;
  }

  function fieldHtml(label, value) {
    return (
      '<div class="bb-ing-detail__field">' +
      '<p class="bb-ing-detail__field-label">' +
      escapeHtml(label) +
      '</p>' +
      '<p class="bb-ing-detail__field-value">' +
      escapeHtml(dashIfEmpty(value)) +
      '</p></div>'
    );
  }

  function renderDetail(slug, pushState) {
    const entry = data.lookup[slug];
    if (!entry || !detailContent) return;

    activeSlug = slug;
    detailContent.innerHTML = buildDetailHtml(entry);
    detailContent.scrollTop = 0;
    bindDetailEvents();
    openDetailPanel();

    root.querySelectorAll('.bb-ing-glossary__link').forEach(function (link) {
      link.classList.toggle('is-selected', link.getAttribute('data-bb-ing-slug') === slug);
    });

    if (pushState !== false) {
      const url = new URL(window.location.href);
      url.searchParams.set('i', slug);
      history.replaceState(null, '', url.toString());
    }
  }

  function bindDetailEvents() {
    if (!detailContent) return;
    detailContent.querySelectorAll('[data-bb-ing-lang]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeLang = btn.getAttribute('data-bb-ing-lang');
        setStoredLang(activeLang);
        if (activeSlug) renderDetail(activeSlug, false);
      });
    });
  }

  function getEnabledLetterButtons() {
    if (!railTrack) return [];
    return Array.prototype.slice.call(
      railTrack.querySelectorAll('[data-bb-ing-letter]:not([disabled])')
    );
  }

  function navigateRailLetter(fromBtn, direction) {
    const buttons = getEnabledLetterButtons();
    const idx = buttons.indexOf(fromBtn);
    if (idx < 0) return;
    const nextIdx = idx + direction;
    if (nextIdx < 0 || nextIdx >= buttons.length) return;
    const nextBtn = buttons[nextIdx];
    const letter = nextBtn.getAttribute('data-bb-ing-letter');
    nextBtn.focus();
    scrollToLetterSection(letter);
  }

  function bindRailKeyboardNav() {
    getEnabledLetterButtons().forEach(function (btn) {
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          navigateRailLetter(btn, 1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          navigateRailLetter(btn, -1);
        } else if (e.key === 'Home') {
          e.preventDefault();
          const first = getEnabledLetterButtons()[0];
          if (!first) return;
          first.focus();
          scrollToLetterSection(first.getAttribute('data-bb-ing-letter'));
        } else if (e.key === 'End') {
          e.preventDefault();
          const buttons = getEnabledLetterButtons();
          const last = buttons[buttons.length - 1];
          if (!last) return;
          last.focus();
          scrollToLetterSection(last.getAttribute('data-bb-ing-letter'));
        }
      });
    });
  }

  function initRailScroll() {
    if (!railTrack) return;

    function updateRailScrollState() {
      const scrollable = railTrack.scrollWidth > railTrack.clientWidth + 2;
      root.classList.toggle('is-rail-scrollable', scrollable);
    }

    updateRailScrollState();

    if (typeof ResizeObserver !== 'undefined') {
      if (root._bbIngRailRo) root._bbIngRailRo.disconnect();
      root._bbIngRailRo = new ResizeObserver(updateRailScrollState);
      root._bbIngRailRo.observe(railTrack);
    }

    if (root._bbIngRailResize) {
      window.removeEventListener('resize', root._bbIngRailResize);
    }
    root._bbIngRailResize = updateRailScrollState;
    window.addEventListener('resize', root._bbIngRailResize);

    if (root._bbIngRailWheel) {
      railTrack.removeEventListener('wheel', root._bbIngRailWheel);
    }
    root._bbIngRailWheel = function (e) {
      if (!root.classList.contains('is-rail-scrollable')) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      railTrack.scrollLeft += e.deltaY;
      e.preventDefault();
    };
    railTrack.addEventListener('wheel', root._bbIngRailWheel, { passive: false });
  }

  function renderRail() {
    if (!railTrack) return;
    const letters = data.letterRail || [];
    const populated = {};
    (data.sections || []).forEach(function (sec) {
      populated[sec.letter] = (sec.items || []).length > 0;
    });

    railTrack.innerHTML = letters
      .map(function (letter) {
        const hasItems = populated[letter];
        if (!hasItems) {
          return (
            '<button type="button" class="bb-ing-glossary__letter is-disabled" disabled ' +
            'data-bb-ing-letter="' +
            escapeHtml(letter) +
            '" aria-disabled="true">' +
            escapeHtml(letter) +
            '</button>'
          );
        }
        return (
          '<button type="button" class="bb-ing-glossary__letter" data-bb-ing-letter="' +
          escapeHtml(letter) +
          '">' +
          escapeHtml(letter) +
          '</button>'
        );
      })
      .join('');

    railTrack.querySelectorAll('[data-bb-ing-letter]:not([disabled])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        scrollToLetterSection(btn.getAttribute('data-bb-ing-letter'));
      });
    });

    bindRailKeyboardNav();

    if ((data.sections || []).length) {
      setActiveLetter(data.sections[0].letter, false);
    }

    initRailScroll();
  }

  function renderDirectory() {
    if (!directoryEl) return;
    if (loadingEl) loadingEl.remove();

    const sections = data.sections || [];
    if (!sections.length) {
      directoryEl.innerHTML =
        '<p class="bb-ing-glossary__loading">No ingredients synced yet. Run glossary sync from Product Content Engine.</p>';
      return;
    }

    directoryEl.innerHTML = sections
      .map(function (sec) {
        const letter = sec.letter;
        const items = sec.items || [];
        const grid = items
          .map(function (item) {
            return (
              '<button type="button" class="bb-ing-glossary__link" data-bb-ing-slug="' +
              escapeHtml(item.slug) +
              '">' +
              escapeHtml(displayInciName(item.name)) +
              '</button>'
            );
          })
          .join('');
        return (
          '<section class="bb-ing-glossary__section" id="bb-ing-section-' +
          escapeHtml(letter) +
          '" data-bb-ing-letter="' +
          escapeHtml(letter) +
          '">' +
          '<h3 class="bb-ing-glossary__section-label">' +
          escapeHtml(letter) +
          '</h3>' +
          '<div class="bb-ing-glossary__grid">' +
          grid +
          '</div></section>'
        );
      })
      .join('');

    directoryEl.querySelectorAll('[data-bb-ing-slug]').forEach(function (link) {
      link.addEventListener('click', function () {
        renderDetail(link.getAttribute('data-bb-ing-slug'));
      });
    });

    initScrollSpy();
  }

  function updateCount() {
    if (!countEl) return;
    const total = data.total || 0;
    countEl.textContent =
      total +
      (total === 1 ? ' ingredient' : ' ingredients') +
      ' · click a name to view details';
  }

  function normalizeSearch(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\u4e00-\u9fff]+/g, ' ')
      .trim();
  }

  function buildSearchIndex() {
    const bySlug = {};
    (data.sections || []).forEach(function (sec) {
      (sec.items || []).forEach(function (item) {
        if (!item || !item.slug) return;
        bySlug[item.slug] = {
          slug: item.slug,
          name: item.name || item.slug,
          letter: sec.letter || '',
          aliases: [],
        };
      });
    });

    Object.keys(data.lookup || {}).forEach(function (slug) {
      const entry = data.lookup[slug] || {};
      const row = bySlug[slug] || {
        slug: slug,
        name: entry.name || slug,
        letter: '',
        aliases: [],
      };
      row.name = entry.name || row.name;
      const aliases = [];
      if (entry.also_known_as) aliases.push(String(entry.also_known_as));
      if (entry.tag_en) aliases.push(String(entry.tag_en));
      if (entry.tag_zh) aliases.push(String(entry.tag_zh));
      row.aliases = aliases
        .join(', ')
        .split(/[,;/|]+/)
        .map(function (part) {
          return part.trim();
        })
        .filter(Boolean);
      bySlug[slug] = row;
    });

    searchIndex = Object.keys(bySlug)
      .map(function (slug) {
        const row = bySlug[slug];
        const haystack = normalizeSearch(
          [row.name].concat(row.aliases).concat([row.slug]).join(' ')
        );
        return {
          slug: row.slug,
          name: row.name,
          letter: row.letter,
          aliases: row.aliases,
          haystack: haystack,
        };
      })
      .sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
  }

  function highlightMatch(text, query) {
    const source = String(text || '');
    const q = String(query || '').trim();
    if (!q) return escapeHtml(source);
    const lowerSource = source.toLowerCase();
    const lowerQuery = q.toLowerCase();
    const idx = lowerSource.indexOf(lowerQuery);
    if (idx < 0) return escapeHtml(source);
    return (
      escapeHtml(source.slice(0, idx)) +
      '<mark>' +
      escapeHtml(source.slice(idx, idx + q.length)) +
      '</mark>' +
      escapeHtml(source.slice(idx + q.length))
    );
  }

  function findMatchingAlias(item, query) {
    const q = normalizeSearch(query);
    if (!q) return '';
    for (let i = 0; i < item.aliases.length; i++) {
      const alias = item.aliases[i];
      if (normalizeSearch(alias).indexOf(q) >= 0) return alias;
    }
    return '';
  }

  function scoreMatch(item, query) {
    const q = normalizeSearch(query);
    if (!q) return -1;
    const nameNorm = normalizeSearch(item.name);
    if (nameNorm === q) return 100;
    if (nameNorm.indexOf(q) === 0) return 90;
    if (nameNorm.indexOf(q) >= 0) return 70;
    for (let i = 0; i < item.aliases.length; i++) {
      const aliasNorm = normalizeSearch(item.aliases[i]);
      if (aliasNorm === q) return 60;
      if (aliasNorm.indexOf(q) === 0) return 50;
      if (aliasNorm.indexOf(q) >= 0) return 40;
    }
    if (item.haystack.indexOf(q) >= 0) return 20;
    return -1;
  }

  function getSearchMatches(query) {
    const q = String(query || '').trim();
    if (q.length < 1) return [];
    const scored = [];
    for (let i = 0; i < searchIndex.length; i++) {
      const item = searchIndex[i];
      const score = scoreMatch(item, q);
      if (score < 0) continue;
      scored.push({ item: item, score: score });
    }
    scored.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.item.name.localeCompare(b.item.name);
    });
    return scored.slice(0, SEARCH_LIMIT).map(function (row) {
      return row.item;
    });
  }

  function setSearchExpanded(open) {
    if (!searchInput) return;
    searchInput.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function hideSearchList() {
    if (!searchList) return;
    searchList.hidden = true;
    searchList.innerHTML = '';
    searchResults = [];
    searchActiveIndex = -1;
    setSearchExpanded(false);
    if (searchInput) searchInput.removeAttribute('aria-activedescendant');
  }

  function updateSearchClearVisibility() {
    if (!searchClear || !searchInput) return;
    searchClear.hidden = !searchInput.value;
  }

  function setSearchActiveOption(index) {
    if (!searchList) return;
    const options = searchList.querySelectorAll('[data-bb-ing-search-slug]');
    if (!options.length) {
      searchActiveIndex = -1;
      return;
    }
    if (index < 0) index = options.length - 1;
    if (index >= options.length) index = 0;
    searchActiveIndex = index;
    options.forEach(function (opt, i) {
      const active = i === searchActiveIndex;
      opt.classList.toggle('is-active', active);
      opt.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) {
        searchInput.setAttribute('aria-activedescendant', opt.id);
        opt.scrollIntoView({ block: 'nearest' });
      }
    });
  }

  function renderSearchResults(query) {
    if (!searchList || !searchInput) return;
    const q = String(query || '').trim();
    updateSearchClearVisibility();

    if (q.length < 1) {
      hideSearchList();
      return;
    }

    searchResults = getSearchMatches(q);
    searchActiveIndex = -1;
    searchInput.removeAttribute('aria-activedescendant');

    if (!searchResults.length) {
      searchList.innerHTML =
        '<li class="bb-ing-glossary__search-empty" role="presentation">' +
        escapeHtml(searchNoResults) +
        '</li>';
      searchList.hidden = false;
      setSearchExpanded(true);
      return;
    }

    searchList.innerHTML = searchResults
      .map(function (item, index) {
        const alias = findMatchingAlias(item, q);
        const showAlias =
          alias && normalizeSearch(alias) !== normalizeSearch(item.name);
        return (
          '<li role="presentation">' +
          '<button type="button" role="option" class="bb-ing-glossary__search-option" ' +
          'id="bb-ing-search-option-' +
          index +
          '" data-bb-ing-search-slug="' +
          escapeHtml(item.slug) +
          '" aria-selected="false">' +
          '<span class="bb-ing-glossary__search-option-name">' +
          highlightMatch(displayInciName(item.name), q) +
          '</span>' +
          (showAlias
            ? '<span class="bb-ing-glossary__search-option-alias">' +
              highlightMatch(alias, q) +
              '</span>'
            : '') +
          '</button></li>'
        );
      })
      .join('');

    searchList.querySelectorAll('[data-bb-ing-search-slug]').forEach(function (btn) {
      btn.addEventListener('mousedown', function (e) {
        e.preventDefault();
      });
      btn.addEventListener('click', function () {
        selectSearchResult(btn.getAttribute('data-bb-ing-search-slug'));
      });
    });

    searchList.hidden = false;
    setSearchExpanded(true);
  }

  function selectSearchResult(slug) {
    if (!slug || !data.lookup[slug]) return;
    const entry = data.lookup[slug];
    if (searchInput) {
      searchInput.value = displayInciName(entry.name || slug);
      updateSearchClearVisibility();
    }
    hideSearchList();
    renderDetail(slug);

    const letterSection = directoryEl
      ? directoryEl.querySelector('[data-bb-ing-slug="' + CSS.escape(slug) + '"]')
      : null;
    if (letterSection) {
      const section = letterSection.closest('.bb-ing-glossary__section');
      const letter = section && section.getAttribute('data-bb-ing-letter');
      if (letter) setActiveLetter(letter, true);
    }
    if (searchInput) searchInput.blur();
  }

  function initSearch() {
    if (!searchInput || !searchList) return;

    searchInput.addEventListener('input', function () {
      const value = searchInput.value;
      window.clearTimeout(searchDebounceTimer);
      searchDebounceTimer = window.setTimeout(function () {
        renderSearchResults(value);
      }, 120);
    });

    searchInput.addEventListener('focus', function () {
      if (searchInput.value.trim()) {
        renderSearchResults(searchInput.value);
      }
    });

    searchInput.addEventListener('keydown', function (e) {
      const listOpen = searchList && !searchList.hidden;
      if (e.key === 'ArrowDown') {
        if (!listOpen) renderSearchResults(searchInput.value);
        if (!searchResults.length) return;
        e.preventDefault();
        setSearchActiveOption(searchActiveIndex + 1);
      } else if (e.key === 'ArrowUp') {
        if (!listOpen || !searchResults.length) return;
        e.preventDefault();
        setSearchActiveOption(searchActiveIndex - 1);
      } else if (e.key === 'Enter') {
        if (!listOpen || !searchResults.length) return;
        e.preventDefault();
        const idx = searchActiveIndex >= 0 ? searchActiveIndex : 0;
        const chosen = searchResults[idx];
        if (chosen) selectSearchResult(chosen.slug);
      } else if (e.key === 'Escape') {
        if (listOpen) {
          e.preventDefault();
          e.stopPropagation();
          hideSearchList();
        } else if (searchInput.value) {
          e.preventDefault();
          searchInput.value = '';
          updateSearchClearVisibility();
        }
      }
    });

    if (searchClear) {
      searchClear.addEventListener('click', function () {
        searchInput.value = '';
        updateSearchClearVisibility();
        hideSearchList();
        searchInput.focus();
      });
    }

    document.addEventListener('click', function (e) {
      if (!searchRoot) return;
      if (!searchRoot.contains(e.target)) {
        hideSearchList();
      }
    });
  }

  function loadData() {
    if (!lookupUrl) return Promise.reject(new Error('No lookup URL'));

    return fetch(lookupUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        data = json;
        buildSearchIndex();
        renderRail();
        renderDirectory();
        updateCount();

        const params = new URLSearchParams(window.location.search);
        const slug = params.get('i') || config.defaultSlug;
        if (slug && data.lookup[slug]) {
          renderDetail(slug, false);
        }
      });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeDetailPanel();
    });
  }
  if (backdropEl) {
    backdropEl.addEventListener('click', closeDetailPanel);
  }
  if (detailEl) {
    detailEl.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (searchList && !searchList.hidden) {
      hideSearchList();
      return;
    }
    if (root.classList.contains('is-detail-open')) {
      closeDetailPanel();
    }
  });

  mobileMq.addEventListener('change', function () {
    if (root.classList.contains('is-detail-open')) {
      document.body.style.overflow = 'hidden';
      if (backdropEl) backdropEl.hidden = false;
    } else {
      document.body.style.overflow = '';
      if (backdropEl) backdropEl.hidden = true;
      updateActiveLetterFromScroll();
    }
  });

  initLang();
  initSearch();
  syncStickyOffset();
  window.addEventListener('resize', syncStickyOffset);
  loadData().catch(function (err) {
    if (directoryEl) {
      directoryEl.innerHTML =
        '<p class="bb-ing-glossary__loading">Could not load ingredient directory. (' +
        escapeHtml(err.message) +
        ')</p>';
    }
  });
})();
